"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Email extends _react.default.Component {
  render() {
    const {
      value,
      onChange
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("input", {
      type: "text",
      className: 'form-control',
      value: value,
      onChange: event => onChange(event.target.value)
    });
  }
}
Email.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func
} : {};
var _default = exports.default = Email;
module.exports = exports.default;